"use client";

import { zodResolver } from "@hookform/resolvers/zod";
import { type PropsWithChildren, useState } from "react";
import { useForm } from "react-hook-form";
import type { z } from "zod";

import {
	Credenza,
	CredenzaBody,
	CredenzaContent,
	CredenzaDescription,
	CredenzaFooter,
	CredenzaHeader,
	CredenzaTitle,
} from "~/components/credenza";
import {
	Form,
	FormButton,
	FormControl,
	FormDescription,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from "~/components/form";
import { Input } from "~/components/input";

import { ImagePreview } from "../image-preview";
import { createOrganization } from "./action";
import { createOrganizationSchema } from "./data";

export function CreateOrganizationDialog({ children }: PropsWithChildren) {
	const [open, setOpen] = useState(false);

	const form = useForm<z.infer<typeof createOrganizationSchema>>({
		resolver: zodResolver(createOrganizationSchema),
		defaultValues: {
			name: "",
			logo: null,
		},
	});

	return (
		<Credenza open={open} onOpenChange={setOpen}>
			{children}
			<Form {...form}>
				<CredenzaContent>
					<form
						className="contents"
						onSubmit={form.handleSubmit(async (data) => {
							await createOrganization(data);

							setOpen(false);
							form.reset();
						}, console.error)}
					>
						<CredenzaHeader>
							<CredenzaTitle>Create Organization</CredenzaTitle>
							<CredenzaDescription>
								Lorem ipsum dolor sit amet, consectetur adipiscing elit.
							</CredenzaDescription>
						</CredenzaHeader>
						<CredenzaBody className="flex flex-col gap-2">
							<FormField
								render={({ field }) => (
									<FormItem>
										<FormLabel>Name</FormLabel>
										<FormControl>
											<Input {...field} />
										</FormControl>
										<FormDescription>
											Your organization name is publicly visible to all customers. It will be used to identify your organization across the platform.
										</FormDescription>
										<FormMessage />
									</FormItem>
								)}
								control={form.control}
								name="name"
							/>
							<FormField
								render={({ field }) => (
									<FormItem className="sm:max-w-64">
										<FormLabel>Icon</FormLabel>
										<FormControl>
											<ImagePreview
												{...field}
												height={128}
												width={128}
											/>
										</FormControl>
										<FormMessage />
									</FormItem>
								)}
								control={form.control}
								name="logo"
							/>
						</CredenzaBody>
						<CredenzaFooter>
							<FormButton>Continue</FormButton>
						</CredenzaFooter>
					</form>
				</CredenzaContent>
			</Form>
		</Credenza>
	);
}
